<template>
    <el-dialog title="新建邮寄地址" :visible.sync="_visible" width="720px">
        <el-form label-width="150px" :model="form">
           
            <el-form-item label="收件人姓名">
                <el-input class="form-input" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="收件人手机号码">
                <el-input class="form-input" v-model="form.mobile"></el-input>
            </el-form-item>
             <el-form-item label="完整地址">
                <el-input :rows="4" type="textarea" class="form-input" v-model="form.address" placeholder="请确保地址正确，否则将导致邮寄不成功"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="$emit('addressHidden')">取消</el-button>
            <el-button @click="addAddress" :disabled="submitting||(!form.address||!form.name||!form.mobile)" type="primary">提交</el-button>
        </span>
    </el-dialog>
</template>

<script>
    // import cityOptions from '../../data/area.js'

    export default {
        props: {
            visible: {
                default: false,
                type: Boolean
            },
        },
        data() {
            return {
                city: '',
                form: {
                    address: ''
                },
                submitting: false,
                addressData: []
            }
        },
        computed: {
            _visible: {
                get() {
                    return this.visible
                },
                set() {
                    this.$emit('addressHidden')
                }
            }
        },
        methods: {

            addAddress() {
                this.submitting = true
                this.$http.post(`personal/address`, this.form).then(res => {
                    if (res.success) {
                        //this.loadAddress()
                        this.$emit('loadAddress')
                        this.$emit('addressHidden')
                    }
                }).catch().then(res => {
                    this.submitting = false
                })
            }
        }
    }

</script>
